import React, { useContext, useState, useEffect } from 'react';
import { AuthContext } from '../context/AuthContext';

const Navbar = ({ currentPage, onChangePage, darkMode, toggleDarkMode, onExport, onCopyEmails, onExportAll, onCopyAllEmails }) => {
    const { user, plan, signInWithGoogle, signOutUser } = useContext(AuthContext);
    const [open, setOpen] = useState(false);
    const [showMenu, setShowMenu] = useState(false);

    // Cerrar el menú móvil si la pantalla se ensancha (ej. al alejar zoom o rotar)
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 768) {
                setOpen(false);
                setShowMenu(false);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Cerrar dropdown al hacer clic fuera en pantallas grandes
    useEffect(() => {
        if (!showMenu) return;

        const handleClickOutside = (e) => {
            if (window.innerWidth > 768 && !e.target.closest('.navbar-dropdown')) {
                setShowMenu(false);
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, [showMenu]);

    const handleNavClick = (page) => {
        onChangePage(page);
        setOpen(false);
    };

    return (
        <nav className="navbar">
            <div className="navbar-left">
                <span className="navbar-brand" onClick={() => handleNavClick('home')}>
                    <img
                        src="/Privi-Leads.png"
                        alt="Privi Lead"
                        className="navbar-logo"
                    />
                </span>
            </div>
            <button
                className={`navbar-toggle ${open ? 'open' : ''}`}
                onClick={() => setOpen(!open)}
                aria-label="Abrir menú"
            >
                <span />
                <span />
                <span />
            </button>
            <div className={`navbar-links ${open ? 'open' : ''}`}>
                <div className="navbar-menu-main">
                    {user && (
                        <>
                            <button
                                className={currentPage === 'home' ? 'active' : ''}
                                onClick={() => handleNavClick('home')}
                            >
                                Buscar
                            </button>
                            <button
                                className={currentPage === 'agenda' ? 'active' : ''}
                                onClick={() => handleNavClick('agenda')}
                            >
                                Mi Agenda
                            </button>
                            <button
                                className={currentPage === 'premium' ? 'active' : ''}
                                onClick={() => handleNavClick('premium')}
                            >
                                Premium
                            </button>
                            <button
                                className={`${currentPage === 'analytics' ? 'active' : ''} nav-analytics`}
                                onClick={() => handleNavClick('analytics')}
                            >
                                📊 Analytics
                            </button>
                        </>
                    )}
                    <button className="theme-toggle" onClick={toggleDarkMode} aria-label="Cambiar tema">
                        {darkMode ? '☀️' : '🌙'}
                    </button>
                    {user && (
                        <div className="navbar-dropdown">
                            <button
                                className={`navbar-menu-toggle ${showMenu ? 'is-open' : ''}`}
                                onClick={() => setShowMenu(!showMenu)}
                                title="Opciones de agenda"
                                aria-expanded={showMenu}
                            >
                                ⋮
                            </button>
                            {showMenu && (
                                <div className="dropdown-menu">
                                    <span className="dropdown-menu-title">Opciones de agenda</span>
                                    <div className="dropdown-menu-group">
                                        <button
                                            className="dropdown-item dropdown-item--primary"
                                            onClick={() => {
                                                onExport();
                                                setShowMenu(false);
                                            }}
                                        >
                                            📄 Exportar Filtrados
                                        </button>
                                        <button
                                            className="dropdown-item dropdown-item--primary"
                                            onClick={() => {
                                                onExportAll();
                                                setShowMenu(false);
                                            }}
                                        >
                                            📦 Exportar Todos
                                        </button>
                                    </div>
                                    <div className="dropdown-menu-group">
                                        <button
                                            className="dropdown-item dropdown-item--secondary"
                                            onClick={() => {
                                                onCopyEmails();
                                                setShowMenu(false);
                                            }}
                                        >
                                            📧 Copiar Emails Filtrados
                                        </button>
                                        <button
                                            className="dropdown-item dropdown-item--secondary"
                                            onClick={() => {
                                                onCopyAllEmails();
                                                setShowMenu(false);
                                            }}
                                        >
                                            📮 Copiar Todos los Emails
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
                <div className="navbar-menu-footer">
                    {user ? (
                        <>
                            <span className="navbar-user">
                                {user.photoURL && (
                                    <img src={user.photoURL} alt={user.displayName || 'Usuario'} />
                                )}
                                {user.displayName || user.email}
                            </span>
                            <button className="btn-secondary" onClick={signOutUser}>Cerrar sesión</button>
                        </>
                    ) : (
                        <button className="btn-primary" onClick={signInWithGoogle}>Iniciar sesión con Google</button>
                    )}
                </div>
            </div>
            {open && (
                <div
                    className="navbar-backdrop"
                    onClick={() => {
                        setOpen(false);
                        setShowMenu(false);
                    }}
                />
            )}
            {/* Modal para suscripción premium */}
        </nav>
    );
};

export default Navbar;


